import React from 'react';
import SolutionPageLayout from '../../components/SolutionPageLayout';
import VedalyticsManagedImage from '../../assets/generated-pages/vedalytics-managed-ai.png';

export default function VedalyticsManaged() {
  return (
    <SolutionPageLayout
      eyebrow="Vedalytics Managed"
      title="Vedalytics Managed Engagement"
      subtitle="End-to-end AI solutions, fully managed by our experts."
      description="Vedalytics Managed Engagement takes complete responsibility for your AI initiatives, from strategy and solution design to development, deployment, optimization, and ongoing support, so your team can focus on business growth."
      image={VedalyticsManagedImage}
      stats={[
        { value: 'End-to-end', label: 'delivery ownership' },
        { value: 'Rapid', label: 'time-to-market focus' },
        { value: 'Managed', label: 'development and operations' },
        { value: 'Quality', label: 'testing and optimization' },
      ]}
      highlights={[
        { icon: 'workflow', title: 'End-to-End Execution', text: 'We handle strategy, architecture, development, testing, launch, and improvement under one managed model.' },
        { icon: 'analytics', title: 'Faster Time-to-Market', text: 'Accelerate delivery with experienced teams, reusable methods, and focused execution.' },
        { icon: 'ai', title: 'AI Excellence', text: 'Apply specialized AI, data, and engineering expertise to create dependable business-ready solutions.' },
      ]}
      overviewTitle="Solutions, fully managed"
      overviewText="This engagement model is designed for teams that want outcomes without managing the day-to-day technical delivery. Vedalytics owns execution while keeping stakeholders informed through clear milestones and governance."
      overviewPoints={[
        'Strategy, architecture, AI development, testing, and deployment managed by Vedalytics.',
        'Clear delivery governance with progress visibility and stakeholder checkpoints.',
        'Ongoing optimization for performance, quality, and business alignment.',
        'Ideal for teams that need speed, expertise, and full technical ownership.',
      ]}
      workflowTitle="How fully managed delivery works"
      workflow={[
        { title: 'Strategy & Planning', text: 'We define the AI vision, delivery roadmap, technical approach, and success measures.' },
        { title: 'Build & Validate', text: 'Vedalytics develops, tests, secures, and refines the solution for business readiness.' },
        { title: 'Deploy Smoothly', text: 'We integrate the solution into your environment with careful rollout and validation.' },
        { title: 'Operate & Improve', text: 'Post-launch support and optimization keep the solution reliable and effective.' },
      ]}
      outcomesTitle="Why teams choose this model"
      outcomes={[
        'Reduced delivery burden on internal teams.',
        'Single accountable partner from concept to launch.',
        'Faster execution with specialist AI capability.',
        'Reliable operations, maintenance, and continuous improvement.',
      ]}
    />
  );
}
